var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.63331 4.03203L4.13331 2.54036L2.95831 3.71536L4.44998 5.20703L5.63331 4.03203ZM3.33331 8.7487H0.833313V10.4154H3.33331V8.7487ZM10.8333 0.457031H9.16665V2.91536H10.8333V0.457031ZM17.0416 3.71536L15.8666 2.54036L14.375 4.03203L15.55 5.20703L17.0416 3.71536ZM14.3666 15.132L15.8583 16.632L17.0333 15.457L15.5333 13.9654L14.3666 15.132ZM16.6666 8.7487V10.4154H19.1666V8.7487H16.6666ZM9.99998 4.58203C7.24165 4.58203 4.99998 6.8237 4.99998 9.58203C4.99998 12.3404 7.24165 14.582 9.99998 14.582C12.7583 14.582 15 12.3404 15 9.58203C15 6.8237 12.7583 4.58203 9.99998 4.58203ZM9.16665 18.707H10.8333V16.2487H9.16665V18.707ZM2.95831 15.4487L4.13331 16.6237L5.62498 15.1237L4.44998 13.9487L2.95831 15.4487Z",
    fill: "#3D3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.2421f543aa708117266847a3b5e77e5d.svg";
export { ForwardRef as ReactComponent };